module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8dTGv"))).then(() => parcelRequire('hEqeo'));